<script>
import Layout from "../../layouts/main";
import ConnectCard from "../../../components/connectCard";
import axios from "axios";
import Multiselect from "vue-multiselect";
import {mapState} from "vuex";
import BlogOverview from "@/components/blogOverview";


/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Blog",
    meta: [{name: "description", content: ''}],
  },
  components: {
    BlogOverview,
    Layout,
    Multiselect,
    ConnectCard
  },
  created() {
    this.addGoogleScript()
  },
  data() {
    return {
      showModal: false,
      showError: false,
      errorMessage: 'Something went wrong.',
      allAccounts: [],
      selectedAccount: null,
      selectedProperty: null,
      selectedProfile: null,
    };
  },
  computed: {
    ...mapState('user', {
      user: (state) => state.user
    }),
    blog() {
      return this.user.social_network_accounts && this.user.social_network_accounts.blog;
    },
    connected() {
      return this.blog && this.blog !== null;
    },
    initialTab() {
      return this.$route.query.tab;
    }
  },
  methods: {
    addGoogleScript() {
      const googleScript = document.createElement('script');
      googleScript.setAttribute('src', 'https://apis.google.com/js/api.js');
      googleScript.setAttribute('async', '');
      googleScript.setAttribute('defer', '');
      googleScript.setAttribute('crossorigin', 'anonymous');
      document.body.appendChild(googleScript);
    },
    loadGoogleAccounts() {
      this.$store.commit('loader/START_LOADING');

      gapi.load('auth2', this.authorizeBlog);

      this.$store.commit('loader/END_LOADING');
    },
    authorizeBlog() {
      //TODO use ajax to /auth2/configuration
      gapi.auth2.authorize({
        client_id: '69136677102-4l5oon39j2kmuspk0257a7m0gchjm0bu.apps.googleusercontent.com',
        scope: 'https://www.googleapis.com/auth/analytics.readonly',
        response_type: 'code',
        access_type: 'offline',
        include_granted_scopes: 'true'
      }, this.blogAuth2callback);
    },
    blogAuth2callback(googleResponse) {
      if(googleResponse.hasOwnProperty('details')) { //User didn't approve permission
        this.errorMessage = googleResponse.details;
        this.showError = true;

        return;
      } else if(googleResponse.hasOwnProperty('error')) { //User didn't approve permission
        this.errorMessage = 'Access denied';
        this.showError = true;

        return;
      }

      this.$store.commit('loader/START_LOADING');

      axios.get(`/profile/blog/connect?code=${googleResponse.code}&redirect_url=${window.location.origin}`)
          .then((response) => {
            this.$store.commit('loader/END_LOADING');
            this.allAccounts = response.data.items;
            this.showModal = true;
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit('loader/END_LOADING');
          });
    },
    async connectBlog(accountId, propertyId, profileId) {
      this.$store.commit('loader/START_LOADING');

      try {
        await axios.post(`/profile/blog/connect`, {
          account_id: accountId,
          web_property_id: propertyId,
          profile_id: profileId
        });
        this.$store.commit('loader/END_LOADING');
        // navigate and force reload
        window.location = '/blog';
      } catch (err) {
        console.error(err);
        this.errorMessage = err.response.data.errors.message[0];
        this.showError = true;
        this.showModal = false;

        this.$store.commit('loader/END_LOADING');
      }
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <b-alert
            v-model="showError"
            class="mt-3"
            variant="danger"
            dismissible
        >{{ errorMessage }}
        </b-alert>
      </div>
    </div>
    <div v-if="connected" class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <b-tabs nav-class="nav-tabs-custom" content-class="text-muted">
              <b-tab :active="!initialTab">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-chart-bar"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Overview</span>
                </template>

                <blog-overview></blog-overview>

              </b-tab>

            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="row">
      <div class="col">
        <ConnectCard social-network="Google Analytics" @connect="loadGoogleAccounts()"/>
      </div>

      <b-modal v-model="showModal" :title="`Choose your account`" size="lg" hide-footer centered>
        <div class="row my-3 justify-content-center">
          <div class="col-8">

            <multiselect class="my-3"
                         v-model="selectedAccount"
                         deselect-label=""
                         track-by="name"
                         label="name"
                         placeholder="Select account"
                         :options="allAccounts"
                         :searchable="false"
                         :allow-empty="false"
                         :multiple="false"></multiselect>

            <multiselect class="my-3"
                         v-if="selectedAccount"
                         v-model="selectedProperty"
                         deselect-label=""
                         track-by="name"
                         label="name"
                         placeholder="Select property"
                         :options="selectedAccount.webProperties"
                         :searchable="false"
                         :allow-empty="false"
                         :multiple="false"></multiselect>

            <multiselect class="my-3"
                         v-if="selectedProperty"
                         v-model="selectedProfile"
                         deselect-label=""
                         track-by="name"
                         label="name"
                         placeholder="Select profile"
                         :options="selectedProperty.profiles"
                         :searchable="false"
                         :allow-empty="false"
                         :multiple="false"></multiselect>

            <button v-if="selectedProfile" @click="connectBlog(selectedAccount.id, selectedProperty.id, selectedProfile.id)"
                    class="btn btn-block btn-primary my-3 btn-blog">
              Connect
            </button>
          </div>
        </div>
      </b-modal>
    </div>
  </Layout>
</template>
